import { useCallback, useState } from 'react';

const DISMISS_MS = 24 * 60 * 60 * 1000;

export function reviewBannerDismissKey(userId: string): string {
  return `disciplined-trader:${userId}:review-banner-dismissed-at`;
}

export function isReviewBannerDismissed(input: {
  userId: string;
  now: number;
  storage: Pick<Storage, 'getItem'>;
}): boolean {
  const value = input.storage.getItem(reviewBannerDismissKey(input.userId));
  if (!value) return false;
  const timestamp = Number(value);
  if (!Number.isFinite(timestamp)) return false;
  return input.now - timestamp < DISMISS_MS;
}

export function useDismissReviewBanner(userId: string | null) {
  const [, setVersion] = useState(0);
  const hidden = userId
    ? isReviewBannerDismissed({
        userId,
        now: Date.now(),
        storage: window.localStorage,
      })
    : false;

  const dismiss = useCallback(() => {
    if (!userId) return;
    window.localStorage.setItem(reviewBannerDismissKey(userId), String(Date.now()));
    setVersion((current) => current + 1);
  }, [userId]);

  return { hidden, dismiss };
}
